import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import UserDetailPage from '@features/admin/users/UserDetailPage.tsx';
import { useCreateAdminUserDetailStore } from '@features/admin/users/useAdminUserDetailStore.ts';

const paramsSchema = z.object({
  userId: z.coerce.number().positive(),
});

export const Route = createFileRoute('/admin/users/$userId')({
  params: {
    parse: v => paramsSchema.parse(v),
  },
  component: RouteComponent,
  beforeLoad: ({ params }) => {
    const userId = paramsSchema.parse(params).userId;
    useCreateAdminUserDetailStore.getState().loadUserDetail(userId);
  },
});

function RouteComponent() {
  const { userId } = Route.useParams();
  return <UserDetailPage userId={userId} />;
}
